import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=6757cc87&"
import script from "./SidebarContent.vue?vue&type=script&lang=js&"
export * from "./SidebarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports